import { useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import qs from 'qs'
import { useTranslation } from 'react-i18next'

import useInitialLoading from 'hooks/useInitialLoading'

import Toast from 'components/Toast/Toast'

import { ACTIVATE_LICENSE } from 'api/payments'

const LicenseActivation = () => {
    const { t } = useTranslation()
    const { onReady } = useInitialLoading()
    const location = useLocation()
    const history = useHistory()

    useEffect(() => {
        const { activationCode } = qs.parse(location.search, { ignoreQueryPrefix: true })
        if (!activationCode) {
            onReady()
            history.push('/my-projects')
            return
        }
        ACTIVATE_LICENSE('atigra', activationCode)
            .then(() => {
                Toast('success', { title: t('License activated successfully!') })
            })
            .catch(err => {
                Toast('error', { title: t('License activation error') })
                console.error(err)
            })
            .finally(() => {
                onReady()
                history.push('/my-projects')
            })
    }, [])

    return null
}

export default LicenseActivation
